import {
	reOrgStoreConstants
}from "./constants"
import actions from '../../actions'

const initialState = {
	isSending : false,
	paged     : {},
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case (reOrgStoreConstants.Create.REQUEST):
		case (reOrgStoreConstants.Update.REQUEST):
		case (reOrgStoreConstants.Delete.REQUEST):
		case (reOrgStoreConstants.GetPaged.REQUEST):
		case (reOrgStoreConstants.Restore.REQUEST) :
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reOrgStoreConstants.Create.FAILURE):
		case (reOrgStoreConstants.Update.FAILURE):
		case (reOrgStoreConstants.Delete.FAILURE):
		case (reOrgStoreConstants.Restore.FAILURE) :
		case (reOrgStoreConstants.GetPaged.FAILURE) :
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (reOrgStoreConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reOrgStoreConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case (reOrgStoreConstants.Update.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (reOrgStoreConstants.Delete.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reOrgStoreConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case (reOrgStoreConstants.CLEAR):
			return {
				...state,
				isSending : false,
				paged     : {},
				changed   : null
			}
		default:
			return state
	}
}